function getFinanceSimulationCarteGrise(financeSimulation) {
  return financeSimulation?.registrationPrice;
}

function getDealCarteGrise(deal) {
  return (
    getFinanceSimulationCarteGrise(deal?.currentDeal?.financeSimulation) ||
    getFinanceSimulationCarteGrise(deal?.financeSimulation)
  );
}

module.exports = {
  getDealCarteGrise,
  getFinanceSimulationCarteGrise,
};
